var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-tabs',{attrs:{"tabs":_vm.tabs},scopedSlots:_vm._u([{key:"default",fn:function({tabSelected}){return [(tabSelected==='Services')?_c('Services'):_vm._e(),(tabSelected==='NomenCats')?_c('NomenCats'):_vm._e(),(tabSelected==='DirectionCats')?_c('DirectionCats'):_vm._e(),(tabSelected==='PriceHistory')?_c('PriceHistory'):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }